import { apiRequest } from '../api/client';

export function kioskCheckIn(documentNumber) {
  return apiRequest('/kiosk/check-in', {
    method: 'POST',
    body: { documentNumber },
  });
}
